import type { AxiosRequestConfig } from 'axios';

import axios from 'axios';

import { CONFIG } from 'src/global-config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: CONFIG.serverUrl });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong!')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  try {
    const [url, config] = Array.isArray(args) ? args : [args];

    const res = await axiosInstance.get(url, { ...config });

    return res.data;
  } catch (error) {
    console.error('Failed to fetch:', error);
    throw error;
  }
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/api/auth/me',
    signIn: '/api/auth/sign-in',
    signUp: '/api/auth/sign-up',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },
  dialer: {
    tenants: '/api/dialer/tenants',
    tenant: (id: number | string) => `/api/dialer/tenants/${id}`,
    users: '/api/dialer/users',
    user: (id: number | string) => `/api/dialer/users/${id}`,
    campaigns: '/api/dialer/campaigns',
    campaign: (name: string) => `/api/dialer/campaigns/${encodeURIComponent(name)}`,
    campaignById: (id: number | string) => `/api/dialer/campaigns/${id}`,
    numbers: (id: number | string) => `/api/dialer/campaigns/${id}/numbers`,
    remaining: (id: number | string) => `/api/dialer/campaigns/${id}/remaining`,
  },
};
